import { BasicIcon, BasicIconsType } from "@pickit/pickit-components";
import { t } from "i18next";
import React, { useCallback } from "react";
import FlowTransition from "../../../../components/FlowTransition/FlowTransition";
import { FlowTrasitionParamsType } from "../../../../components/FlowTransition/types";
import FirstPage from "./FirstPage/FirstPage";
import { OperateTabProps } from "./types";
import { TABS_ICONS } from "pages/Home/components/Faq/types";
import FaqTab from "pages/Home/components/Faq/components/FaqTab/FaqTab";
import "./operateTab.scss";

const OperateTab: React.FC<OperateTabProps> = ({
  back,
  backPage,
  initialSubSection,
  initialQuestion,
  firstRender,
  setFirstRender,
}) => {
  const PAGES = {
    Delivery: "Delivery",
    PickUp: "PickUp",
    Initial: "Inital",
  };
  const PagesOrder = [PAGES.PickUp, PAGES.Delivery];
  const handleClick = useCallback(
    (page: string) => () => {
      back(page);
      if (setFirstRender) setFirstRender();
    },
    [back, setFirstRender]
  );

  return (
    <div>
      <div>
        <button className="mobile-option active">
          <div>
            <BasicIcon
              name={TABS_ICONS.Operate as BasicIconsType}
              color="#0098ff"
            />
            <p>{t(`faq:operate`) as string}</p>
          </div>
          <BasicIcon name="x" clickable onClick={handleClick(backPage)} />
        </button>
      </div>

      <FlowTransition
        pages={{
          [PAGES.Initial]: (props: FlowTrasitionParamsType) => (
            <FirstPage
              {...props}
              pickUp={PAGES.PickUp}
              deliver={PAGES.Delivery}
            />
          ),
          [PAGES.PickUp]: (props: FlowTrasitionParamsType) => (
            <FaqTab
              {...props}
              tab="PickUp"
              backPage={PAGES.Initial}
              initialQuestion={firstRender ? initialQuestion : undefined}
              setFirstRender={setFirstRender}
            />
          ),
          [PAGES.Delivery]: (props: FlowTrasitionParamsType) => (
            <FaqTab
              {...props}
              tab="Deliver"
              backPage={PAGES.Initial}
              initialQuestion={firstRender ? initialQuestion : undefined}
              setFirstRender={setFirstRender}
            />
          ),
        }}
        firstPage={
          initialSubSection !== undefined
            ? PagesOrder[initialSubSection]
            : PAGES.Initial
        }
        indexPage={PAGES.Initial}
        isOpen
      />
    </div>
  );
};

export default OperateTab;
